import axios from "axios";

export const baseUrlDaApiV2 = () => {
  const env = process.env.REACT_APP_ENV || "development";
  const porAmbiente = {
    production: process.env.REACT_APP_BASE_URL_PRODUCTION,
    staging: process.env.REACT_APP_BASE_URL_STAGING,
    development: process.env.REACT_APP_BASE_URL_DEV,
  };
  return `${porAmbiente[env] || process.env.REACT_APP_BASE_URL_DEV}/api/v2`;
};

export const caminhoDoEvento = (eventId, ...partes) =>
  [
    "metrics",
    "events",
    encodeURIComponent(String(eventId)),
    ...partes.map((parte) => encodeURIComponent(String(parte))),
  ].join("/") + "/";

export const CINCO_MINUTOS = 5 * 60 * 1000;

export const repetirSoErroDeServidor = (tentativas, erro) => {
  const status = erro?.response?.status;
  if (status && status < 500) return false;
  return tentativas < 2;
};

const useApiV2 = () => {
  const axiosInstance = axios.create({
    baseURL: baseUrlDaApiV2(),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  });

  const obter = async (caminho, params) => {
    const response = await axiosInstance.get(caminho, { params });
    return response.data;
  };

  const getEvents = (params) => obter("/events/", params);

  const getEventImpact = (eventId, params) =>
    obter(`/${caminhoDoEvento(eventId, "impact")}`, params);

  const getCollectionChangeImpact = (changeId, params) =>
    obter(
      `/metrics/collection-changes/${encodeURIComponent(String(changeId))}/impact/`,
      params
    );

  const getEventTimeseries = (eventId, params) =>
    obter(`/${caminhoDoEvento(eventId, "timeseries")}`, params);

  const getEventsTimeseries = (params) =>
    obter("/metrics/events/timeseries/", params);

  const getCollectionChangeTimeseries = (changeId, params) =>
    obter(
      `/metrics/collection-changes/${encodeURIComponent(String(changeId))}/timeseries/`,
      params
    );

  const getEventSkus = (eventId, params) =>
    obter(`/${caminhoDoEvento(eventId, "skus")}`, params);

  const getEventSkuTimeseries = (eventId, produto, params) =>
    obter(
      `/${caminhoDoEvento(eventId, "skus", produto, "timeseries")}`,
      params
    );

  const getRevenueMetrics = (params) => obter("/metrics/revenue/", params);

  const getGoalMetrics = (params) => obter("/metrics/goals/", params);

  const getConversionMetrics = (params) =>
    obter("/metrics/conversion/", params);

  const getDerivedMetrics = (params) => obter("/metrics/derived/", params);

  const getCollectionsEfficiency = (params) =>
    obter("/metrics/collections/efficiency/", params);

  const getCollectionsZoneTimeline = (params) =>
    obter("/metrics/collections/zone-timeline/", params);

  const getAttentionMetrics = (params) => obter("/metrics/attention/", params);

  const getQueueMetrics = (params) => obter("/metrics/queue/", params);

  const getHeatmap = (params) => obter("/heatmap/", params);

  const getZoneAllocation = (params) =>
    obter("/metrics/revenue/zone-allocation/", params);

  const getProducts = (params) => obter("/products/", params);

  const getStockAvailable = (params) => obter("/stock/available/", params);

  const getRScoreMetrics = (params) => obter("/metrics/rscore/", params);

  const getCollectionBranches = (params) =>
    obter("/metrics/collections/branches/", params);

  const getCollectionsList = (params) => obter("/collections/", params);

  const getCategoryVariation = (params) =>
    obter("/metrics/categories/variation/", params);

  const getCategoryVariationSkus = (params) =>
    obter("/metrics/categories/variation/skus/", params);

  const getLostSalesSummary = (params) => obter("/metrics/lost-sales/", params);

  const getLostSalesReasons = (params) =>
    obter("/metrics/lost-sales/reasons/", params);

  const getLostSalesLogs = (params) =>
    obter("/metrics/lost-sales/logs/", params);

  const getLostSalesProducts = (params) =>
    obter("/lost-sales/products/", params);

  const getCategoryProducts = (params) =>
    obter("/metrics/categories/products/", params);

  const getCategoryProductTimeseries = (produto, params) =>
    obter(
      `/metrics/categories/products/${encodeURIComponent(produto)}/timeseries/`,
      params
    );

  return {
    getEvents,
    getEventImpact,
    getCollectionChangeImpact,
    getEventTimeseries,
    getEventsTimeseries,
    getCollectionChangeTimeseries,
    getEventSkus,
    getEventSkuTimeseries,
    getRevenueMetrics,
    getGoalMetrics,
    getConversionMetrics,
    getDerivedMetrics,
    getCollectionsEfficiency,
    getCollectionsZoneTimeline,
    getAttentionMetrics,
    getQueueMetrics,
    getHeatmap,
    getZoneAllocation,
    getProducts,
    getStockAvailable,
    getRScoreMetrics,
    getCollectionBranches,
    getCollectionsList,
    getCategoryVariation,
    getCategoryVariationSkus,
    getLostSalesSummary,
    getLostSalesReasons,
    getLostSalesLogs,
    getLostSalesProducts,
    getCategoryProducts,
    getCategoryProductTimeseries,
  };
};

export default useApiV2;
